export enum TABS {
  share = 'share',
  stats = 'stats',
}
